var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { MarketSection, MyAssetsTab } from '../../app/router/config';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import { TokenType } from '../../types/common';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
import { checkIfWalletAsEnoughCurrency } from '../../utils/balances';
import { strFloatToTokenQuantity } from '../../utils/blockchain';
import { MAX_POWER_VALUE, MIN_POWER_VALUE, getPowersToFilter } from '../../utils/card-powers';
import { getMintPassNameFromKey } from '../../utils/filters';
import { getImxOrders } from '../../utils/imx-orders';
import { metadataFactions, metadataSeasons } from '../../utils/products';
import { useInput } from '../common/use-input';
import { useImxActions } from '../imx/use-imx-actions';
export function useMyOffers(filters, section) {
    var t = useI18n().t;
    var _a = useContext(LoadingContext), imxLoading = _a.imxLoading, setImxLoading = _a.setImxLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _b = useContext(UserContext), user = _b.user, balances = _b.balances, selectedWallet = _b.selectedWallet, localWalletAddress = _b.localWalletAddress, fees = _b.fees;
    var _c = useContext(CurrencyContext), tokens = _c.tokens, usdcAddress = _c.usdcAddress, imxClient = _c.imxClient, queue = _c.queue, parseCurrencyQuantity = _c.parseCurrencyQuantity;
    var imxActions = useImxActions();
    var _d = useState(null), offers = _d[0], setOffers = _d[1];
    var _e = useState(null), displayedOffers = _e[0], setDisplayedOffers = _e[1];
    var _f = useState({ cta: undefined, usdc: undefined }), cursors = _f[0], setCursors = _f[1];
    var _g = useState({ cta: -1, usdc: -1 }), remainings = _g[0], setRemainings = _g[1];
    var _h = useState(0), refreshCount = _h[0], setRefreshCount = _h[1];
    var _j = useState(undefined), selectedOfferId = _j[0], setSelectedOfferId = _j[1];
    var _k = useState(undefined), selectedOrder = _k[0], setSelectedOrder = _k[1];
    var _l = useState(undefined), selectedPrice = _l[0], setSelectedPrice = _l[1];
    var makeOfferPrice = useInput('');
    useEffect(function () {
        filters.actions.setTokenTypes(section === MarketSection.MINT_PASSES ? [TokenType.MINT_PASS] : [TokenType.CARD]);
    }, [section]);
    useEffect(function () {
        setOffers(null);
        setDisplayedOffers(null);
        getOffers({ refresh: true });
    }, [
        usdcAddress,
        imxClient,
        fees,
        filters.state.currencyTokens,
        filters.state.tokenTypes,
        filters.state.advancements,
        filters.state.collections,
        filters.state.sets,
        filters.state.factions,
        filters.state.elements,
        filters.state.rarities,
        filters.state.minPower,
        filters.state.maxPower,
        filters.state.grades,
        filters.state.foils,
        filters.state.ranks,
        filters.state.animationLevels,
        filters.state.cardTypes,
        filters.state.mintPassTypes,
        filters.state.numberings,
        filters.state.searchQuery.value,
        filters.state.orderBy,
        filters.state.direction,
        selectedWallet,
    ]);
    useEffect(function () {
        if (!tokens || !selectedOfferId || !selectedOrder || !selectedPrice || !selectedWallet)
            return;
        var hasEnoughCurrency = makeOfferPrice.value.length > 0
            ? checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, selectedOrder.buy.data.token_address || '', strFloatToTokenQuantity(makeOfferPrice.value, tokens, selectedOrder.buy.data.token_address || ''))
            : true;
        var makeOfferPriceTooLow = Number.parseFloat(makeOfferPrice.value) < Number.parseFloat(selectedPrice.value) * 0.1;
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.MAKE_OFFER
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                action: function () { return updateOffer(selectedOfferId, selectedOrder, makeOfferPrice); },
                                disabled: !hasEnoughCurrency ||
                                    makeOfferPriceTooLow ||
                                    makeOfferPrice.value.length === 0 ||
                                    Number.parseFloat(makeOfferPrice.value) === 0,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { makeOfferPrice: makeOfferPrice, notEnoughCurrency: !hasEnoughCurrency, makeOfferPriceTooLow: makeOfferPriceTooLow }),
                }
                : value;
        });
    }, [user, selectedOrder, selectedPrice, makeOfferPrice.value, selectedWallet, balances, localWalletAddress]);
    function getOffers(options) {
        return __awaiter(this, void 0, void 0, function () {
            var parsedFilters, result, newRefreshCount, container;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!usdcAddress ||
                            !imxClient ||
                            imxLoading ||
                            !fees ||
                            !selectedWallet ||
                            filters.state.tab !== MyAssetsTab.OFFERS)
                            return [2 /*return*/];
                        setImxLoading(true);
                        setCursors(function (value) { return ((options === null || options === void 0 ? void 0 : options.refresh) ? { cta: undefined, usdc: undefined } : value); });
                        parsedFilters = {
                            tokenType: filters.state.tokenTypes.length > 0 ? filters.state.tokenTypes : undefined,
                            season: filters.state.collections.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.collections.map(function (collection) { return metadataSeasons[collection - 1]; })
                                : undefined,
                            set: filters.state.sets.length > 0 ? filters.state.sets.map(function (set) { return set.toString(); }) : undefined,
                            faction: filters.state.factions.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.factions.map(function (faction) { return metadataFactions[faction]; })
                                : undefined,
                            advancement: filters.state.advancements.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.advancements
                                : undefined,
                            element: filters.state.elements.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.elements
                                : undefined,
                            grade: filters.state.grades.length > 0 &&
                                (filters.state.tokenTypes[0] === TokenType.CARD || filters.state.tokenTypes[0] === TokenType.SOUVENIR_CARD)
                                ? filters.state.grades
                                : undefined,
                            rarity: filters.state.rarities.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.rarities
                                : undefined,
                            power: filters.state.tokenTypes[0] === TokenType.CARD &&
                                (filters.state.minPower !== MIN_POWER_VALUE || filters.state.maxPower !== MAX_POWER_VALUE)
                                ? getPowersToFilter(filters.state.minPower, filters.state.maxPower)
                                : undefined,
                            rank: filters.state.ranks.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.ranks.map(function (rank) { return rank.toString(); })
                                : undefined,
                            foil: filters.state.foils.length === 1 &&
                                (filters.state.tokenTypes[0] === TokenType.CARD || filters.state.tokenTypes[0] === TokenType.SOUVENIR_CARD)
                                ? filters.state.foils.map(function (value) { return value === true; })
                                : undefined,
                            animationLevel: filters.state.animationLevels.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.animationLevels
                                : undefined,
                            cardType: filters.state.cardTypes.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.cardTypes
                                : undefined,
                            name: filters.state.mintPassTypes.length > 0 && filters.state.tokenTypes[0] === TokenType.MINT_PASS
                                ? getMintPassNameFromKey(filters.state.mintPassTypes)
                                : undefined,
                            numbering: filters.state.numberings.length > 0 ? filters.state.numberings.map(function (value) { return value.toString(); }) : undefined,
                        };
                        return [4 /*yield*/, getImxOrders(imxClient, usdcAddress, queue, fees, offers, filters.state.tokenTypes[0], filters.state.currencyTokens, parsedFilters, filters.state.orderBy, filters.state.direction, cursors, (options === null || options === void 0 ? void 0 : options.refresh) ? undefined : remainings, parseCurrencyQuantity, __assign(__assign({}, options), { buyProps: true, buyTokenName: filters.state.searchQuery.value, user: selectedWallet.address }))];
                    case 1:
                        result = _a.sent();
                        newRefreshCount = (options === null || options === void 0 ? void 0 : options.refresh) ? 1 : refreshCount + 1;
                        setOffers(result.orders);
                        setDisplayedOffers(result.orders.length > 200 * newRefreshCount ? __spreadArray([], result.orders, true).slice(0, 200 * newRefreshCount) : result.orders);
                        setCursors(result.cursors);
                        setRemainings(result.remainings);
                        setRefreshCount(newRefreshCount);
                        if (options === null || options === void 0 ? void 0 : options.refresh) {
                            container = window.document.getElementById('my-assets-offers-table');
                            container === null || container === void 0 ? void 0 : container.scrollTo({ top: 0 });
                        }
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function loadMoreOffers() {
        getOffers({ refresh: false });
    }
    function showCancelOfferDialog(offerId) {
        setDialogProps({
            common: {
                title: t('common.cancel-offer'),
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [{ highlighted: true, text: t('common.confirm'), action: function () { return cancelOffer(offerId); } }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('cancel-offer.message'),
            },
        });
    }
    function cancelOffer(offerId) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.cancelOrder({ walletFrom: selectedWallet, orderId: offerId })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            if (err_1.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_1.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_1.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[cancelOffer] ".concat(err_1));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, getOffers({ refresh: true })];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.cancel-offer'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('cancel-offer.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showUpdateOfferDialog(offerId) {
        return __awaiter(this, void 0, void 0, function () {
            var offer, auxiliaryFee, response, orderPrice, price;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        offer = offers === null || offers === void 0 ? void 0 : offers.find(function (offer) { return offer.order.order_id === offerId; });
                        if (!offer || !imxClient || !fees)
                            return [2 /*return*/];
                        setImxLoading(true);
                        auxiliaryFee = fees.buyer > 0
                            ? { auxiliaryFeeRecipients: appEnv.blockchain.feeAddress, auxiliaryFeePercentages: fees.buyer.toString() }
                            : {};
                        return [4 /*yield*/, queue.add(function () {
                                return imxClient.listOrders(__assign({ status: 'active', sellTokenId: offer.order.buy.data.token_id || '', sellTokenAddress: appEnv.blockchain.collectionAddress, orderBy: 'sell_quantity', direction: 'desc', pageSize: 1, includeFees: true }, auxiliaryFee));
                            })];
                    case 1:
                        response = _d.sent();
                        orderPrice = response.result.length > 0
                            ? parseCurrencyQuantity(response.result[0].buy.data.quantity_with_fees, response.result[0].buy.data.token_address)
                            : undefined;
                        price = orderPrice
                            ? {
                                tokenSymbol: (_a = orderPrice.base) === null || _a === void 0 ? void 0 : _a.symbol,
                                value: ((_b = orderPrice.base) === null || _b === void 0 ? void 0 : _b.displayValue) || '',
                                usdValue: ((_c = orderPrice.usd) === null || _c === void 0 ? void 0 : _c.displayValue) || '',
                            }
                            : undefined;
                        setSelectedOfferId(offerId);
                        setSelectedOrder(response.result.length > 0 ? response.result[0] : undefined);
                        setSelectedPrice(price);
                        setImxLoading(false);
                        setDialogProps(price
                            ? {
                                common: {
                                    title: t('common.update-offer'),
                                    close: { text: t('common.cancel'), action: hideGenericDialog },
                                    actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
                                },
                                custom: {
                                    type: DialogType.MAKE_OFFER,
                                    assetPrice: price,
                                    makeOfferPrice: makeOfferPrice,
                                    buyTokenAddress: offer.order.buy.data.token_address || '',
                                    notEnoughCurrency: false,
                                    makeOfferPriceTooLow: false,
                                    update: true,
                                },
                            }
                            : {
                                common: {
                                    title: t('common.error'),
                                    close: { text: t('common.back'), action: hideGenericDialog },
                                },
                                custom: {
                                    type: DialogType.SIMPLE,
                                    message: t('update-offer.not-on-sale'),
                                },
                            });
                        return [2 /*return*/];
                }
            });
        });
    }
    function updateOffer(offerId, order, price) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet || !tokens)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, imxActions.cancelOrder({ walletFrom: selectedWallet, orderId: offerId })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, sleep(5000)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, imxActions.makeOffer({
                                walletFrom: selectedWallet,
                                buyTokenId: order.sell.data.token_id || '',
                                sellQuantity: strFloatToTokenQuantity(price.value, tokens, order.buy.data.token_address || ''),
                                sellTokenAddress: order.buy.data.token_address || '',
                            })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_2 = _a.sent();
                        console.error(err_2);
                        if (err_2 instanceof Error) {
                            if (err_2.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_2.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_2.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[makeOffer] ".concat(err_2));
                        }
                        return [3 /*break*/, 6];
                    case 6:
                        if (!!error) return [3 /*break*/, 10];
                        return [4 /*yield*/, sleep(4000)];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, sleep(4000)];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, getOffers({ refresh: true })];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.update-offer'),
                                close: { text: t('common.back'), action: hideGenericDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('update-offer.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function hideGenericDialog() {
        setDialogProps(undefined);
        setSelectedOfferId(undefined);
        setSelectedOrder(undefined);
        setSelectedPrice(undefined);
        makeOfferPrice.setValue('');
    }
    return {
        offers: displayedOffers,
        getOffers: getOffers,
        loadMoreOffers: loadMoreOffers,
        showCancelOfferDialog: showCancelOfferDialog,
        showUpdateOfferDialog: showUpdateOfferDialog,
    };
}
